<section class="bg-white  shadow p-4 md:p-6">
  <div class="flex items-center justify-between">
    <h2 class="font-semibold uppercase text-xl sm:text-2xl md:text-3xl bg-black text-white p-2 rounded-t-xl text-gray-900">Ingressos</h2>
    <span *ngIf="badgeText" class="text-xs text-white bg-[#E90128] px-3 py-1 rounded-full">{{ badgeText }}</span>
  </div>

  <div class="mt-4 divide-y">
    <p class="border-4 w-full border-black mb-4"></p>

    <div class="py-3 flex items-center justify-between" *ngFor="let lot of lots; trackBy: trackById">
      <div class="flex items-center gap-6">
        <div class="font-bold text-gray-900">{{ lot.name }}</div>
        <div class="text-sm text-gray-600">{{ lot.until || '—' }}</div>

      </div>

      <div class="flex items-center gap-4">
        <div class="text-gray-900 font-bold">{{ lot.price | currency:'BRL':'symbol':'1.0-0' }}</div>
        <span
          *ngIf="lot.actionLabel === 'Inscrito'; else buyAction"
          class="inline-flex h-9 items-center rounded-3xl bg-emerald-100 px-4 text-sm font-bold text-emerald-700"
        >
          Inscrito
        </span>
        <ng-template #buyAction>
        <button class="h-9 px-4 rounded-3xl font-bold shadow
                   text-white transition
                   disabled:opacity-60 disabled:cursor-not-allowed
                   bg-[#E90128] hover:bg-[#c70020]"
                [disabled]="lot.soldOut"
                (click)="select.emit(lot)">
          {{ lot.actionLabel || (lot.soldOut ? 'Esgotado' : 'Comprar') }}
        </button>
        </ng-template>
      </div>
    </div>

  </div>
</section>